<template>
  <card class="border border-danger">
    <template slot="header">
      <h4 class="card-title">{{ $t('accountDelete.finalise.title') }}</h4>
    </template>
    <template>
      <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
        <!-- TODO: add error translation -->
        {{ getActionErrorDetails }}
      </base-alert>
      <div>
        <base-radio inline name="delete" class="mb-3" v-model="formDetails.action">
          {{ $t('accountDelete.finalise.deleteRadioTitle') }}
        </base-radio>
        <base-radio inline name="cancel" class="mb-3" v-model="formDetails.action">
          {{ $t('accountDelete.finalise.cancelRadioTitle') }}
        </base-radio>
      </div>
      <form @submit.prevent="validate()">
        <div>
          <div class="row" >
            <div class="col-12" v-if="formDetails.action === 'delete' && account.balance != 0">
              <base-checkbox
                inline
                v-model="formDetails.forceDelete"
                type="primary">
                {{ $t('accountDelete.finalise.forceDeletionSwitch') }}
              </base-checkbox>
            </div>
            <div class="col-12"  v-if="formDetails.action === 'cancel'">
              <base-input :label="$t('accountDelete.finalise.cancelDescription')"
                          :error="getError('cancel_description')">
                <textarea class="form-control"
                          :placeholder="$t('accountDelete.finalise.cancelDescriptionPlaceholder')"
                          name="cancel_description"
                          v-validate="modelValidations.cancel_description"
                          v-model="formDetails.cancel_description"
                          rows="2"></textarea>
              </base-input>
            </div>
            <div class="col-12">
              <base-button class="mt-3" native-type="submit"
                           :type=" formDetails.action == 'cancel'? 'primary' : 'danger'" :loading="updating"
                           :disabled="submitBtnDisabled">{{
                  formDetails.action == 'delete' ?
                    $t('accountDelete.finalise.submitDeleteBtnTitle') : $t('accountDelete.finalise.submitCancelBtnTitle')
                }}
              </base-button>
            </div>
          </div>
        </div>
      </form>
    </template>
  </card>
</template>
<script>
import {BaseAlert, BaseRadio, BaseSwitch} from 'src/components'
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";
import swal from 'sweetalert2';

export default {
  name: 'finaliseDeletingAccount',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    BaseAlert,
    BaseRadio,
    BaseSwitch
  },
  props: {},
  data() {
    return {
      alert: false,
      formDetails: {
        forceDelete: false,
        action: 'delete',
        cancel_description: '',
      },
      modelValidations: {
        cancel_description: {
          required: true,
        },
      },
    };
  },
  computed: {
    ...mapState({
      updating: state => state.account_deletion.updating,
      error: state => state.account_deletion.error,
      account: state => state.account.data,
    }),
    getActionErrorDetails() {
      return this.error;
    },
    submitBtnDisabled: function () {
      let action = this.formDetails.action
      let forceDelete = this.formDetails.forceDelete
      let account = this.account
      if (action === 'cancel' || account.balance == 0) {
        return false
      }

      return !forceDelete
    }
  },
  methods: {
    ...mapActions(['CancelAccountDeletion', 'DeleteAccount', 'LoadAccount']),

    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    confirmAlert(titleText, text) {
      swal({
        titleText: titleText,
        text: text ? text : null,
        buttonsStyling: false,
        confirmButtonText: this.$t('accountDelete.finalise.confirmAlert.actionBtnLabel'),
        cancelButtonText: this.$t('accountDelete.finalise.confirmAlert.cancelBtnLabel'),
        confirmButtonClass: 'btn btn-primary',
        cancelButtonClass: 'btn btn-secondary',
        type: 'question',
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.finaliseAccountDelete();
        }
      })
    },
    validate() {
      if (this.formDetails.action == 'cancel') {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            let titleText = this.$t('accountDelete.finalise.confirmAlert.canceledTitle')
            this.confirmAlert(titleText, null)
          }
        });
      } else {
        this.confirmAlert(this.$t('accountDelete.finalise.confirmAlert.confirmTitle'), this.$t('accountDelete.finalise.confirmAlert.confirmText'));
      }
    },
    finaliseAccountDelete() {
      if (this.formDetails.action === 'cancel') {
        // DO cancel
        this.CancelAccountDeletion({
          accountID: this.account.id,
          payload: {cancel_description: this.formDetails.cancel_description},
        }).then(() => {
          if (this.error != null) {
            this.alert = true
            // got error, don't reset form
          } else {
            this.$notify({
              type: 'success',
              message: this.$t('accountDelete.finalise.canceledNotification'),
              icon: 'tim-icons icon-alert-circle-exc'
            })
            this.LoadAccount(this.account.id)
          }
        });
      } else {
        // Do delete
        this.DeleteAccount(this.account.id).then(() => {
          if (this.error != null) {
            this.alert = true
            // got error, don't reset form
          } else {
            this.$notify({
              type: 'success',
              message: this.$t('accountDelete.finalise.deletedNotification'),
              icon: 'tim-icons icon-alert-circle-exc'
            })
            this.LoadAccount(this.account.id)
          }
        });
      }
    }
  },
};
</script>
<style></style>
